module.exports = "/_next/static/images/63d1455ade5aa88c13078d09e4287576-mother-and-daugther@1x.jpg.webp";